import { render, staticRenderFns } from "./ReportePermisos.vue?vue&type=template&id=6674d164&"
import script from "./ReportePermisos.vue?vue&type=script&lang=js&"
export * from "./ReportePermisos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports